import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import YumChooseIntegrationBtn from './YumChooseIntegrationBtn'
import { setOnboardingStatusToIntegration } from '../../views/RegisterUser/store/RegisterUserActions'
import { IStateProps } from '../YumSetupActivityData/YumSetupActivityData'

const mapStateToProps = (state: IGlobalState, { buttonText }: IStateProps): IStateProps => ({
  buttonText,
})

const mapDispatchToProps = {
  setOnboardingStatusToIntegration,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumChooseIntegrationBtn)
